import EditProjectForm from './EditProjectForm';

export default EditProjectForm;
